export interface SharedState {
  filterCount: number;
  benefitDocumentAutoPopupDisabled: boolean;
}

export const initialSharedState: SharedState = {
  filterCount: 0,
  benefitDocumentAutoPopupDisabled: false,
};
